import Link from "next/link";
import React from "react";
import { UrlObject } from "url";
import { WorkspaceModel } from "lib/types/workspaces/WorkspaceModel";
import { useWorkspaces } from "lib/hooks/useWorkspaces";
import WorkspaceSvg from "components/icons/WorkspaceIcon";
import Card from "../Card/Card";
import SpanNoWrap from "../Text/SpanNoWrap";

const ListItemProjectDropdown = ({
  href,
  title,
  projectWorkspace,
  ...rest
}: {
  href?: string | UrlObject;
  title?: string;
  projectWorkspace: WorkspaceModel;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const { workspaces: usersWorkspaces, isLoading } = useWorkspaces();

  if (isLoading) {
    return null;
  }

  let component = (
    <Card>
      {" "}
      <div className="flex cursor-pointer flex-row items-center pr-4 hover:bg-gray-50">
        <div className="border-r px-3 py-1">
          <WorkspaceSvg />
        </div>

        <div className="flex h-16 items-center justify-between ">
          <div className="flex w-full justify-center">
            <div className="flex-1 overflow-hidden px-3 ">
              <div className="flex font-light text-gray-700">
                <SpanNoWrap>{title}</SpanNoWrap>
              </div>
              <div className="flex text-xs font-light text-gray-400">
                <SpanNoWrap>{projectWorkspace.name}</SpanNoWrap>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );

  if (href) component = <Link href={href}>{component}</Link>;

  return (
    <div className="w-full" {...rest}>
      {component}
    </div>
  );
};

export default ListItemProjectDropdown;
